import { z } from 'zod/v4';

import { licenseHistorySchema } from './license-history.schema';

export const userLicenseAssignmentSchema = z.object({
  externalId: z.string().min(1),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  licenses: z.array(licenseHistorySchema),
});

export type UserLicenseAssignment = z.infer<typeof userLicenseAssignmentSchema>;
